import React from "react";
// import CryptoDashboard from "../pages/dashboards/crypto/CryptoDashboard";
// import ListingDashboard from "../pages/dashboards/listing/ListingDashboard";
// import CrmDashboard from "../pages/dashboards/crm/CrmDashboard";
// import IntranetDashboard from "../pages/dashboards/intranet/IntranetDashboard";
// import EcommerceDashboard from "../pages/dashboards/ecommerce/EcommerceDashboard";
// import NewsDashboard from "../pages/dashboards/news/NewsDashboard";
// import MiscDashboard from "../pages/dashboards/misc/MiscDashboard";



import Page from "@jumbo/shared/Page";

const Login = React.lazy(() => import('../pages/dashboards/table/Login'));
const Ticket = React.lazy(() => import('../pages/dashboards/table/ticket2'));
const TicketNew = React.lazy(() => import('../pages/dashboards/table/ticketnew'));
const TransactionUser = React.lazy(() => import('../pages/dashboards/table/TransactionUser'));
const TransactionRealUser = React.lazy(() => import('../pages/dashboards/table/TransactionRealUser'));
const TicketDetails = React.lazy(() => import('../pages/dashboards/table/ticketdetails'));
const DataTables = React.lazy(() => import('../pages/dashboards/table/index'));
const EditProfile = React.lazy(() => import('../pages/dashboards/table/EditProfile'));
const Dashboard = React.lazy(() => import('../pages/dashboards/table/Dashboard'));
const ListCompany = React.lazy(() => import('../pages/dashboards/table/ListCompany'));
const ListHome = React.lazy(() => import('../pages/dashboards/table/ListHome'));
const HomeDetails = React.lazy(() => import('../pages/dashboards/table/homedetails'));


const dashboardRoutes = [
    {
        path: "/dashboard",
        element: <Page component={ListHome}/>
    },
    // {
    //     path: "/crypto",
    //     element: <Page component={CryptoDashboard} />,
    // },
    // {
    //     path: "/listing",
    //     element: <Page component={ListingDashboard}/>,
    // },
    // {
    //     path: "/crm",
    //     element: <Page component={CrmDashboard}/>,
    // },
    {
        path: "/transactionuser",
        element: <Page component={TransactionUser}/>,
    },
    {
        path: "/paymentuser",
        element: <Page component={TransactionRealUser}/>,
    },
    // {
    //     path: "/intranet",
    //     element: <Page component={IntranetDashboard} />,
    // },
    // {
    //     path: "/ecommerce",
    //     element: <Page component={EcommerceDashboard}/>,
    // },
    // {
    //     path: "/news",
    //     element: <Page component={NewsDashboard}/>,
    // },
    {
        path: "/employee",
        element: <Page component={DataTables}/>
    },
    {
        path: "/company",
        element: <Page component={ListCompany}/>
    },
    {
        path: "/login",
        element: <Page component={Login}/>
    },
    {
        path: "/editprofile",
        element: <Page component={EditProfile}/>
    },

    {
        path: "/table",
        element: <Page component={DataTables}/>
    },
    {
        path: "/ticket",
        element: <Page component={Ticket}/>
    }
    ,
    {
        path: "/ticketnew",
        element: <Page component={TicketNew}/>
    }
    ,
    {
        path: "/ticketdetails/:id",
        element: <Page component={TicketDetails}/>
    }
    ,
    {
        path: "/homedetails/:id",
        element: <Page component={HomeDetails}/>
    }
];

export default dashboardRoutes;
